import { render, staticRenderFns } from "./Enhanced_focus_avoiding.vue?vue&type=template&id=45a6734b"
import script from "./Enhanced_focus_avoiding.vue?vue&type=script&lang=js"
export * from "./Enhanced_focus_avoiding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports